export const LegalWritingEventName = 'LegalWritingEvent'
export const FormEventName = 'FormEventName'

export enum LegalWritingStatus {
  SELECTION,
  WRITING,
  SENDING,
  SENDEND,
  RECIVED,
  CANCELED
}

export enum Subsections {
  SELECTION = 'Selección del tipo de escrito',
  WRITING = 'Realizando el escrito',
  SENDING = 'Enviando el escrito'
}

export enum LegalWritingType {
  NO_DEFINIDO = 'no definido',
  TRAMITE = 'trámite',
  ASUNTO = 'asunto',
  EJECUCION = 'ejecución',
  REVISION_SENTENCIA = 'revision de sentencia'
}

export enum TipoPersonaMaster {
  JURIDICA = '001',
  FISICA = '002',
  SIN_ENTIDAD = '003'
}

export enum Orden {
  ESPECIAL,
  CIVIL,
  PENAL,
  CONTENCIOSO,
  SOCIAL,
  MILITAR,
  CONSTITUCIONAL
}

export enum TipoMensaje {
  ACUSE = 1,
  ESCRITO = 2,
  NOTIFICACION = 3,
  RECIBI = 4,
  ITINERACION = 5,
  INICIADOR_ASUNTO = 6,
  INICIADOR_EJECUCION = 7,
  MENSAJE_INTERNACIONAL = 10,
  TRASLADO = 11,
  INICIADOR_ATESTADO = 12,
  INICIADOR_PARTE_HOSPITALARIO = 13,
  PERSONACION = 14,
  RECURSO_QUEJA = 15,
  ESCRITO_DEFENSA = 16,
  RECURSO_CASACION = 17,
  INICIADOR_ATESTADO_DILIGENCIA = 19,
  INICIADOR_RECURSO_DE_REVISION_DE_SENTENCIA_FIRME = 21,
  JUICIO_RÁPIDO = 22,
  MONITORIO = 23,
  MONITORIO_CATALOGO = 101
}

export enum TipoMensajeDescripcion {
  ACUSE = 'Acuse',
  ESCRITO = 'Escrito de trámite',
  NOTIFICACION = 'Notificación',
  RECIBI = 'Recibi',
  ITINERACION = 'Itineración',
  INICIADOR_ASUNTO = 'Iniciador de asunto',
  INICIADOR_EJECUCION = 'Iniciador de ejecución',
  MENSAJE_INTERNACIONAL = 'Mensaje internacional',
  MONITORIO = 'Monitorio',
  TRASLADO = 'Traslado',
  INICIADOR_ATESTADO = 'Iniciador de atestado',
  INICIADOR_PARTE_HOSPITALARIO = 'Iniciador de parte hospitalario',
  PERSONACION = 'Personación',
  RECURSO_QUEJA = 'Recurso de queja',
  ESCRITO_DEFENSA = 'Escrito de defensa',
  RECURSO_CASACION = 'Recurso de casación',
  INICIADOR_ATESTADO_DILIGENCIA = 'Iniciador de atestado de diligencia',
  INICIADOR_RECURSO_DE_REVISION_DE_SENTENCIA_FIRME = 'Iniciador de recurso de revisión de sentencia firme',
  JUICIO_RÁPIDO = 'Juicio rápido'
}

export enum TipoEscrito {
  ESCRITO = 1,
  BORRADOR = 2,
  PLANTILLA = 3
}

export enum EstadoEscrito {
  SIN_ENVIAR = 1,
  ENVIADO = 2,
  ACEPTADO = 3,
  RECHAZADO = 4
}

export enum TipoAdjunto {
  PRINCIPAL = 0,
  ANEXO = 1,
  AMBOS = 2
}

export enum DocumentosPermitidos {
  PRINCIPAL = '.pdf',
  ANEXOS = '.pdf,.rtf,.jpeg,.jpg,.tif,.odt,.zip,.csig,.sig,.p7s,.xsig,.xmp,.dsig,.gml,.gz,.mpeg,.mp4,.csv,.txt,.html,.htm,.css,.mhtml,.mht,.ods,.odp,.odg,.docx,.xlsx,.pptx,.png,.svg,.tiff,.mp3,.ogg,.oga,.webm,.n3,.ttl,.xml,.xsd'
}

export enum TipoMensajeURLPath {
  ASUNTO = 'iniciador-asunto',
  EJECUCION = 'iniciador-ejecucion',
  ESCRITOS = 'escritos',
  MONITORIO = 'monitorio',
  PERSONACION = 'personacion',
  QUEJA = 'recurso-queja',
  SENTENCIA = 'sentencia-firme',
  TRAMITE = 'tramite'
}

export enum CautelarOpciones {
  SI = 'Sí',
  NO = 'No'
}

export enum ResolucionOpciones {
  SI = 'Sí',
  NO = 'No'
}

export enum SiNoOpciones {
  SI = 'Sí',
  NO = 'No'
}

export enum TipoCuantiaOpciones {
  DETERMINADA = 'Determinada',
  INDETERMINADA = 'Indeterminada',
  NO_PROCEDE = 'No procede'
}

export enum LiteralTiposOrden {
  ESPECIAL = 'ESPECIAL',
  CIVIL = 'CIVIL',
  PENAL = 'PENAL',
  CONTENCIOSO = 'CONTENCIOSO',
  SOCIAL = 'SOCIAL',
  MILITAR = 'MILITAR',
  CONSTITUCIONAL = 'CONSTITUCIONAL'
}

export enum TipoResolucion {
  ACUERDO = 'Acuerdo',
  AUTO = 'Auto',
  DECRETO = 'Decreto',
  PROVIDENCIA = 'Providencia',
  SENTENCIA = 'Sentencia'
}
